import React from 'react';
import { styled } from '@mui/material';
import { Dialog, DialogTitle } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import ErrorMessage from 'components/common/ErrorMessage';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { useDispatch } from 'react-redux';
import { adminEditTravelTime } from 'slices/dashboardSlice';
import { interpreterEditTravelTime } from 'slices/interpreter/dashboardSlice';

const BootstrapDialog = styled(Dialog)(() => ({
  '& .MuiDialog-container': {
    overflowY: 'auto',
    margin: 'auto',
    alignItems: 'flex-start',
  },
  '& .MuiPaper-root': {
    maxHeight: 'none',
    overflowY: 'hidden',
    borderRadius: 20,
  },
}));

const EditTravelTimeModal = ({ show, onClose, onSuccess, item, isAdmin = true }) => {
  const dispatch = useDispatch();

  const { control, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: { date: '', start_time: '', end_time: '', notes: '' },
  });

  React.useEffect(() => {
    if (show && item) {
      reset({
        date: item.date || '',
        start_time: item.start_time ? item.start_time.substring(0, 5) : '',
        end_time: item.end_time ? item.end_time.substring(0, 5) : '',
        notes: item.appointment_details?.notes || '',
      });
    }
  }, [show, item]);

  const onSubmit = (data) => {
    const action = isAdmin ? adminEditTravelTime : interpreterEditTravelTime;
    dispatch(action(item.id, data, (success, message) => {
      if (success) {
        toast.success(message, { className: 'successToast' });
        onClose();
        if (onSuccess) onSuccess();
      } else {
        toast.error(message || 'Something went wrong', { className: 'errorToast' });
      }
    }));
  };

  return (
    <BootstrapDialog
      fullWidth
      maxWidth="md"
      onClose={onClose}
      open={show}
      sx={{
        '& .MuiDialog-container': { alignItems: 'center' },
        '& .MuiPaper-root': { overflowY: 'visible' },
      }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="modal-content full_modal">
          <DialogTitle>
            <div className="modal-header header_modal align-items-center">
              <div></div>
              <h5 className="modal-title_u">Edit Travel Time</h5>
              <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
            </div>
          </DialogTitle>

          <div className="modal-body modal_form_body">
            <div className="row-primary">
              <div className="date" style={{ flex: 1 }}>
                <h2>Date *</h2>
                <Controller
                  name="date"
                  control={control}
                  rules={{ required: 'Date is required' }}
                  render={({ field }) => (
                    <div style={{ width: '100%' }}>
                      <div className="input-image">
                        <input type="date" {...field} />
                        <img src="/images/celender.png" alt="calendar" className="custom-icon" />
                      </div>
                      {errors?.date?.message && <ErrorMessage text={errors.date.message} />}
                    </div>
                  )}
                />
              </div>
            </div>

            <div className="row-primary row-r mt-3">
              <div className="date">
                <h2>Start Time <span style={{ fontWeight: 400, fontSize: '13px' }}>(optional)</span></h2>
                <Controller
                  name="start_time"
                  control={control}
                  render={({ field }) => (
                    <div className="input-image">
                      <input type="time" {...field} />
                      <img src="/images/clock.png" alt="clock" className="custom-icon" />
                    </div>
                  )}
                />
              </div>
              <div className="date">
                <h2>End Time <span style={{ fontWeight: 400, fontSize: '13px' }}>(optional)</span></h2>
                <Controller
                  name="end_time"
                  control={control}
                  render={({ field }) => (
                    <div className="input-image">
                      <input type="time" {...field} />
                      <img src="/images/clock.png" alt="clock" className="custom-icon" />
                    </div>
                  )}
                />
              </div>
            </div>

            <div className="row-primary mt-3">
              <h2>Notes</h2>
              <Controller
                name="notes"
                control={control}
                render={({ field }) => (
                  <textarea
                    {...field}
                    className="type_inp input-in"
                    placeholder="Enter notes (optional)"
                  />
                )}
              />
            </div>

            <div className="modal-body d-flex justify-content-end gap-2 mt-2">
              <button type="button" className="Cancle_button" onClick={onClose}>Cancel</button>
              <SubmitButton buttonType="submit" btnText="Save" />
            </div>
          </div>
        </div>
      </form>
    </BootstrapDialog>
  );
};

export default EditTravelTimeModal;
